import React from 'react';
import { Button, Checkbox, Typography, theme } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import type { SettingsController } from '../../hooks/useSettings';
import { SettingsCard } from './parts';

const { Text } = Typography;

export const ResetDataCard: React.FC<{ s: SettingsController }> = ({ s }) => {
  const { token } = theme.useToken();
  return (
    <SettingsCard
      title={<Text strong style={{ color: token.colorError }}>Reset Data</Text>}
      icon={<DeleteOutlined style={{ color: token.colorError }} />}
      style={{ borderColor: token.colorError }}
      extra={
        <Button
          danger
          type="primary"
          size="small"
          icon={<DeleteOutlined />}
          onClick={s.handleFactoryReset}
          loading={s.resetting}
          disabled={s.resetSections.length === 0}
        >
          Reset Selected
        </Button>
      }
    >
      <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 8 }}>
        Select the data you want to permanently delete. This action cannot be undone.
      </Text>
      <Checkbox.Group
        value={s.resetSections}
        onChange={(vals) => s.setResetSections(vals as string[])}
        options={[
          { label: 'Servers (with their check data)', value: 'servers' },
          { label: 'Health Data (Redis)', value: 'redis' },
          { label: 'Tickets', value: 'tickets' },
          { label: 'Reports', value: 'reports' },
          { label: 'Webhooks', value: 'webhooks' },
          { label: 'API Keys', value: 'apiKeys' },
          { label: 'Check Logs', value: 'checkLogs' },
          { label: 'Workers (manual only)', value: 'workers' },
          { label: 'Settings (reset to defaults)', value: 'settings' },
        ]}
        style={{ fontSize: 12 }}
      />
      {s.resetSections.includes('servers') && (
        <Text type="secondary" style={{ fontSize: 12, display: 'block', marginTop: 8 }}>
          Deleting servers also removes everything they put in Redis — health, history,
          flapping and egress keys. There is no separate option: reports are built by
          scanning Redis, so data left behind would come back in the next report as
          failing endpoints of servers that no longer exist.
        </Text>
      )}
      {s.resetSections.includes('checkLogs') && !s.resetSections.includes('servers') && (
        <Text type="warning" style={{ fontSize: 12, display: 'block', marginTop: 8 }}>
          Note: Check logs will reappear as long as the checker is running and servers exist.
          To fully stop new logs, also delete Servers or stop the checker service.
        </Text>
      )}
    </SettingsCard>
  );
};

export default ResetDataCard;
